<template>
    <div class="_moving">
        <logo/>
        <div class="_moving_conter">
            <Controls v-model="controlsData" v-if="activeIndex == 0"/>
            <Manage :controlsData="controlsData" v-else/>
        </div>
         <div class="_moving_sidebar">
            <sidebar v-model="activeIndex"/>
        </div>
    </div>
</template>

<script>
import logo from "./modules/logo.vue";
import sidebar from "./modules/sidebar.vue";
import Controls from "./controls.vue";
import Manage from "./manage.vue";
import { watch } from "vue";
export default {
    name: "",
    components: { logo,sidebar,Controls,Manage},
    methods:{
        changeActiveIndex(index) {
            this.activeIndex = index;
        }
    },
    data() {
        return {
            activeIndex: 0,
            controlsData:null
        }
    },
    watch:{
        controlsData(newData){
            console.log('数据变化',newData)
        }
    },
}
</script>



<style lang="scss">
._moving{
    height: 100vh;
    width: 100%;
    background: url('./img/home_bg.png') center / cover no-repeat, rgb(9,38,80);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    display:flex;
    flex-direction: column;
    user-select: none;
    &_conter{
        flex:1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        margin:0 30px;
    }
    &_sidebar{
        flex-shrink: 0;
    }
}
</style>